module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("分类浏览")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "type-list"
  }, [_vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": _vm.baseUri + item.href
      }
    }, [_vm._v("\n          " + _vm._s(item.title)), _c('span')])])
  }), _vm._v(" "), _c('li')], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-564f38d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Types.vue
// module id = 198
// module chunks = 0